// extracted by mini-css-extract-plugin
export default {"wrapper":"cart-summary_wrapper__9i8Am"};